import funLogoImage from 'assets/images/pink-square-logo.png';
import cx from 'classnames';
import { resourceUrl } from 'helpers/url.helper';
import React, { HtmlHTMLAttributes } from 'react';
import { useAppSelector } from 'store/store-hooks';
import './title-and-logo.css';

export type VerticalUILogoProps = HtmlHTMLAttributes<HTMLImageElement> & {
  hideVerticalUILogo?: boolean;
};

const VerticalUILogo: React.FC<VerticalUILogoProps> = ({
  hideVerticalUILogo = false,
  ...rest
}) => {
  const { boothInfo, isVerticalScreen } = useAppSelector(
    (state) => state.booth,
  );

  if (!isVerticalScreen || hideVerticalUILogo) return null;

  return (
    <img
      src={
        boothInfo?.LogoImageUrl
          ? resourceUrl(boothInfo?.LogoImageUrl)
          : funLogoImage
      }
      {...rest}
      alt="vertical logo fun"
      className={cx('title-and-logo__logo', rest?.className)}
    />
  );
};

export default VerticalUILogo;
